export const getErrorMessage = (
  t: (key: string) => string,
  errorCode?: string,
): string => {
  const errorMessages: Record<string, string> = {
    "PROMO_CODE.NOT_FOUND": t("promocode.apply.error.notfound"),
    "PROMO_CODE.HAS_EXPIRED": t("promocode.apply.error.expired"),
    "PROMO_CODE.HAS_BEEN_USED": t("promocode.apply.error.used"),
  };

  return errorCode && errorMessages[errorCode] ? errorMessages[errorCode] : "";
};
